import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import ReactGA from 'react-ga';
import ScrollableAnchor from 'react-scrollable-anchor';
import Banner from '../containers/Banner';
import Home from '../containers/page/Home';
import About from '../containers/page/About';
import Catalog from '../containers/page/Catalog';
import Contact from '../containers/page/Contact';
import News from '../containers/page/News';
import Location from '../containers/page/Location';
import Product from '../containers/page/Product';
import Register from '../containers/page/Register';
import Search from '../containers/page/Search';
import Admin from '../containers/page/Admin';
import BackToTop from './BackToTop';
import { googleAnalyticsId } from '../config/config'

// The Main component renders one of the three provided
// Routes (provided that one matches). Both the /roster
// and /schedule routes will match any pathname that starts
// with /roster or /schedule. The / route will only match
// when the pathname is exactly the string "/"
const Main = () => {
  let logPageView;
  if(process.env.NODE_ENV === 'production'){
    logPageView = (props) => {
      if (typeof window !== 'undefined'){
        ReactGA.set({ page: props.location.pathname });
        ReactGA.pageview(props.location.pathname);
      }
      return null;
    };
    ReactGA.initialize(googleAnalyticsId);
  }
  return (
    <main>
      <ScrollableAnchor id={'main'}>
        <div />
      </ScrollableAnchor>
      {logPageView && <Route component={logPageView} />}
      <Route path="/:page?/:filter?" component={Banner} />
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/about/:filter" component={About} />
        <Route path="/catalog" component={Catalog} />
        <Route path="/contact" component={Contact} />
        <Route path="/news/:filter/:id?" component={News} />
        <Route path="/locations/:filter?" component={Location} />
        <Route path="/product/:id/:filter?" component={Product} />
        <Route path="/register" component={Register} />
        <Route path="/search/:query?" component={Search} />
        <Route path="/admin" component={Admin} />
        <Route render={() => <Redirect to="/" />} />
      </Switch>
      <BackToTop />
    </main>
  );
};

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main.js